import React, { Component } from "react";
import HelperClass from "../../../config/helperClass";
import Tooltip from "@material-ui/core/Tooltip";
import { createTrunk, getOutboundSBCAccounts, getOutboundSBCIntegration } from "../../../config/reseller_api_calls";

const auth = new HelperClass();

class AddTrunk extends Component {
  constructor(props) {
    super(props);
    this.topRef = React.createRef();
    this.state = {
      loading: false,
      errorMessage: "",
      successMessage: "",
      currentStep: 1, // 1 or 2
      
      // SIP NAV Accounts
      sipnavAccounts: [],
      loadingAccounts: true,

      // Limits from sipnav_integration_details
      maxSessions: 500,
      maxCps: 50,
      accountIps: [],
      carrierIps: [],

      formData: {
        // SIP NAV Account Selection
        selected_account_id: "",
        selected_client_name: "",

        // Limits (defaults until fetched)
        limit_sessions: 100,
        limit_cps: 10,
        
        // General Configuration
        trunk_name: "",
        dtmf: "in-band",
        tls_encryption: false,
        fax: "none",
        codecs: ["g729", "pcma", "pcmu"],
        number_format: "e164",
        
        // Inbound Route 
        source_hosts: [],
        
        // Outbound Route 
        destination_hosts: [],
        resolve_srv: false,
        routing_strategy: "failover",
      },
      formErrors: {},
      
      // Temporary inputs
      tempSourceHost: "",
      tempSourceTechPrefix: "",
      tempSourceType: "both",
      tempDestHost: "",
      tempDestTechPrefix: "",
      tempDestType: "both",
      draggedSourceIndex: null,
      draggedDestIndex: null,
    };
  }

  componentDidMount() {
    if (auth.isLogin() === false) {
      auth.logout();
    } else {
      this.fetchSipNavAccounts();
      this.fetchSipnavLimits();
    }
  }

  fetchSipNavAccounts = async () => {
    try {
      this.setState({ loadingAccounts: true });
      const response = await getOutboundSBCAccounts(
        auth.getAccount(),
        auth.getToken()
      );
      
      if (response.data.status === 200 && response.data.data) {
        this.setState({ 
          sipnavAccounts: response.data.data,
          loadingAccounts: false 
        });
      } else {
        this.setState({
          sipnavAccounts: [],
          loadingAccounts: false,
          errorMessage: response.data.message || "No SIP NAV accounts found"
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      console.error("Error fetching SIP NAV accounts:", error);
      this.setState({
        sipnavAccounts: [],
        loadingAccounts: false,
        errorMessage: "Failed to load SIP NAV accounts"
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  fetchSipnavLimits = async () => {
    try {
      const response = await getOutboundSBCIntegration(auth.getAccount(), auth.getToken());
      console.log("[fetchSipnavLimits] raw response:", response.data);

      if (response.data.status !== 200) {
        console.warn("[fetchSipnavLimits] non-200 status:", response.data.status, response.data.message);
        return;
      }

      if (!response.data.data) {
        console.warn("[fetchSipnavLimits] data is null — no sipnav integration record found for this account");
        return;
      }

      const { session_limit, cps_limit, account_ips, carrier_ips } = response.data.data;
      console.log("[fetchSipnavLimits] session_limit:", session_limit, "cps_limit:", cps_limit);

      const maxSessions = parseInt(session_limit) || 500;
      const maxCps = parseInt(cps_limit) || 50;
      const accountIps = account_ips ? account_ips.split(",").map(ip => ip.trim()).filter(Boolean) : [];
      const carrierIps = carrier_ips ? carrier_ips.split(",").map(ip => ip.trim()).filter(Boolean) : [];

      this.setState({
        maxSessions,
        maxCps,
        accountIps,
        carrierIps,
        formData: {
          ...this.state.formData,
          limit_sessions: Math.round(maxSessions / 5),
          limit_cps: Math.round(maxCps / 5),
        },
      });
    } catch (e) {
      console.error("[fetchSipnavLimits] error:", e.message, e);
    }
  };

  handleGoBack = () => {
    this.props.props.history.push("/all_trunks");
  };

  handleSessionsChange = (value) => {
    const clamped = Math.max(0, Math.min(this.state.maxSessions, parseInt(value) || 0));
    this.setState({ formData: { ...this.state.formData, limit_sessions: clamped } });
  };

  incrementSessions = () => {
    const next = Math.min(this.state.maxSessions, this.state.formData.limit_sessions + 10);
    this.setState({ formData: { ...this.state.formData, limit_sessions: next } });
  };

  decrementSessions = () => {
    const next = Math.max(0, this.state.formData.limit_sessions - 10);
    this.setState({ formData: { ...this.state.formData, limit_sessions: next } });
  };

  handleCpsChange = (value) => {
    const clamped = Math.max(0, Math.min(this.state.maxCps, parseInt(value) || 0));
    this.setState({ formData: { ...this.state.formData, limit_cps: clamped } });
  };

  incrementCps = () => {
    const next = Math.min(this.state.maxCps, this.state.formData.limit_cps + 1);
    this.setState({ formData: { ...this.state.formData, limit_cps: next } });
  };

  decrementCps = () => {
    const next = Math.max(0, this.state.formData.limit_cps - 1);
    this.setState({ formData: { ...this.state.formData, limit_cps: next } });
  };

  handleInputChange = (field, value) => {
    if (field === "trunk_name") {
      // Letters and spaces only, max 30 characters
      value = value.replace(/[^a-zA-Z ]/g, "").slice(0, 30);
    }
    this.setState({
      formData: { ...this.state.formData, [field]: value },
    });
  };

  toggleCodec = (codec) => {
    const { codecs } = this.state.formData;
    const index = codecs.indexOf(codec);
    let newCodecs;
    
    if (index > -1) {
      newCodecs = codecs.filter((c) => c !== codec);
    } else {
      newCodecs = [...codecs, codec];
    }
    
    this.setState({
      formData: { ...this.state.formData, codecs: newCodecs },
    });
  };

  addSourceHost = () => {
    const { tempSourceHost, tempSourceTechPrefix, tempSourceType } = this.state;
    if (!tempSourceHost) return;

    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const validIp = ipv4Regex.test(tempSourceHost) &&
      tempSourceHost.split(".").every((o) => Number(o) >= 0 && Number(o) <= 255);
    if (!validIp) {
      this.setState({ errorMessage: "Inbound IP Address is not a valid IPv4 address (e.g. 34.51.220.120)." });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (tempSourceTechPrefix && !/^\d{1,7}$/.test(tempSourceTechPrefix)) {
      this.setState({ errorMessage: "Inbound Tech Prefix must be numbers only and no more than 7 digits." });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    this.setState({
      formData: {
        ...this.state.formData,
        source_hosts: [...this.state.formData.source_hosts, {
          ip: tempSourceHost,
          tech_prefix: tempSourceTechPrefix || "",
          type: tempSourceType || "termination",
        }],
      },
      tempSourceHost: "",
      tempSourceTechPrefix: "",
      tempSourceType: "termination",
      errorMessage: "",
    });
  };

  removeSourceHost = (index) => {
    this.setState({
      formData: { ...this.state.formData, source_hosts: this.state.formData.source_hosts.filter((_, i) => i !== index) },
    });
  };

  handleSourceDragStart = (index) => {
    this.setState({ draggedSourceIndex: index });
  };

  handleSourceDragOver = (e, index) => {
    e.preventDefault();
  };

  handleSourceDrop = (e, dropIndex) => {
    e.preventDefault();
    const { draggedSourceIndex } = this.state;
    if (draggedSourceIndex === null || draggedSourceIndex === dropIndex) return;

    const hosts = [...this.state.formData.source_hosts];
    const draggedHost = hosts[draggedSourceIndex];
    hosts.splice(draggedSourceIndex, 1);
    hosts.splice(dropIndex, 0, draggedHost);

    this.setState({
      formData: { ...this.state.formData, source_hosts: hosts },
      draggedSourceIndex: null,
    });
  };

  addDestHost = () => {
    const { tempDestHost, tempDestTechPrefix, tempDestType } = this.state;
    if (!tempDestHost) return;

    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const validIp = ipv4Regex.test(tempDestHost) &&
      tempDestHost.split(".").every((o) => Number(o) >= 0 && Number(o) <= 255);
    if (!validIp) {
      this.setState({ errorMessage: "Outbound IP Address is not a valid IPv4 address (e.g. 34.51.220.120)." });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (tempDestTechPrefix && !/^\d{1,7}$/.test(tempDestTechPrefix)) {
      this.setState({ errorMessage: "Outbound Tech Prefix must be numbers only and no more than 7 digits." });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    this.setState({
      formData: {
        ...this.state.formData,
        destination_hosts: [...this.state.formData.destination_hosts, {
          ip: tempDestHost,
          tech_prefix: tempDestTechPrefix || "",
          type: tempDestType || "termination",
        }],
      },
      tempDestHost: "",
      tempDestTechPrefix: "",
      tempDestType: "termination",
      errorMessage: "",
    });
  };

  removeDestHost = (index) => {
    this.setState({
      formData: { ...this.state.formData, destination_hosts: this.state.formData.destination_hosts.filter((_, i) => i !== index) },
    });
  };

  handleDestDragStart = (index) => {
    this.setState({ draggedDestIndex: index });
  };

  handleDestDragOver = (e, index) => {
    e.preventDefault();
  };

  handleDestDrop = (e, dropIndex) => {
    e.preventDefault();
    const { draggedDestIndex } = this.state;
    if (draggedDestIndex === null || draggedDestIndex === dropIndex) return;

    const hosts = [...this.state.formData.destination_hosts];
    const draggedHost = hosts[draggedDestIndex];
    hosts.splice(draggedDestIndex, 1);
    hosts.splice(dropIndex, 0, draggedHost);

    this.setState({
      formData: { ...this.state.formData, destination_hosts: hosts },
      draggedDestIndex: null,
    });
  };

  handleContinue = () => {
    // Validate required fields
    if (!this.state.formData.selected_account_id) {
      this.setState({ errorMessage: "Please select a SIP NAV account" });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    
    if (!this.state.formData.trunk_name) {
      this.setState({ errorMessage: "SIP Trunk Name is required." });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (!/^[a-zA-Z ]{1,30}$/.test(this.state.formData.trunk_name)) {
      this.setState({ errorMessage: "SIP Trunk Name must be letters only and no more than 30 characters." });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    
    if (this.state.formData.source_hosts.length === 0 && this.state.formData.destination_hosts.length === 0) {
      this.setState({ errorMessage: "At least one Inbound (Source) or Outbound (Destination) host is required" });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    
    this.setState({ currentStep: 2, errorMessage: "" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleBack = () => {
    this.setState({ currentStep: 1 });
  };

  handleSubmit = async () => {
    this.setState({ loading: true, errorMessage: "", successMessage: "" });
    
    try {
      const response = await createTrunk(
        auth.getAccount(),
        auth.getToken(),
        this.state.formData
      );
      
      if (response.data.status === 200) {
        this.setState({
          loading: false,
          successMessage: "SIP Trunk created successfully! Redirecting..."
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.props.props.history.push("/all_trunks");
        }, 2000);
      } else {
        this.setState({
          loading: false,
          errorMessage: response.data.message || "Failed to create SIP trunk. Please try again."
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      console.error("Error creating trunk:", error);
      this.setState({
        loading: false,
        errorMessage: error.response?.data?.message || "An error occurred while creating the trunk. Please try again."
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  render() {
    const { currentStep, formData, errorMessage, successMessage, tempSourceHost, tempSourceTechPrefix, tempSourceType, tempDestHost, tempDestTechPrefix, tempDestType, loading, loadingAccounts, sipnavAccounts, maxSessions, maxCps, accountIps, carrierIps } = this.state;
    const { limit_sessions, limit_cps } = formData;
    const step = (max) => Math.round(max / 5);
    const sessionPresets = [0, Math.round(step(maxSessions) / 2), step(maxSessions), Math.round((step(maxSessions) + maxSessions) / 2), maxSessions];
    const cpsPresets     = [0, Math.round(step(maxCps) / 2),     step(maxCps),     Math.round((step(maxCps) + maxCps) / 2),         maxCps];

    return (
      <div className="nk-content nk-content-fluid" ref={this.topRef}>
        <div className="">
          <div className="nk-content-body">
            {/* Header */}
            <div className="nk-block-head nk-block-head-sm">
              <div className="nk-block-between">
                <div className="nk-block-head-content">
                  <h3 className="nk-block-title page-title">
                    {currentStep === 1 ? "Configure SIP Trunk" : "Review & Submit"}
                  </h3>
                  <div className="nk-block-des text-soft">
                    <p>
                      <strong>STEP {currentStep} OF 2</strong> -{" "}
                      {currentStep === 1
                        ? "Set the number of channels, routing hosts, and call settings."
                        : "Review your SIP trunk configuration and submit to create."}
                    </p>
                  </div>
                </div>
                <div className="nk-block-head-content">
                  <button className="btn btn-outline-light" onClick={this.handleGoBack}>
                    <em className="icon ni ni-arrow-left mr-1"></em>
                    Back
                  </button>
                </div>
              </div>
            </div>

            {/* Alerts */}
            {errorMessage && (
              <div className="example-alert" style={{ marginBottom: "15px" }}>
                <div className="alert alert-pro alert-danger">
                  <div className="alert-text">
                    <h4>Error</h4>
                    <p>{errorMessage}</p>
                  </div>
                </div>
              </div>
            )}

            {successMessage && (
              <div className="example-alert" style={{ marginBottom: "15px" }}>
                <div className="alert alert-pro alert-success">
                  <div className="alert-text">
                    <h4>Success</h4>
                    <p>{successMessage}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Step 1: Configuration Form */}
            {currentStep === 1 && (
              <div className="nk-block">
                {/* Limit Sessions + Calls Per Second */}
                <div className="card card-bordered mb-3">
                  <div className="card-inner">
                    <div className="row no-gutters">

                      {/* ── Calls Per Second (CPS) — LEFT ── */}
                      <div className="col-md-6 pr-4" style={{ borderRight: "1px solid #e5e9f2" }}>
                        <h6 className="title mb-1">CALLS PER SECOND (CPS)</h6>
                        <p className="text-soft small mb-3">Maximum new calls allowed per second. Max: {maxCps}.</p>
                        <div className="d-flex align-items-center">
                          <button
                            className="btn btn-outline-light btn-lg"
                            onClick={this.decrementCps}
                            style={{ fontSize: "24px", padding: "10px 20px" }}
                          >
                            −
                          </button>
                          <input
                            type="number"
                            className="form-control form-control-lg text-center mx-3"
                            value={formData.limit_cps}
                            onChange={(e) => this.handleCpsChange(e.target.value)}
                            min={0}
                            max={maxCps}
                            style={{ width: "120px", fontSize: "24px" }}
                          />
                          <button
                            className="btn btn-outline-light btn-lg"
                            onClick={this.incrementCps}
                            style={{ fontSize: "24px", padding: "10px 20px" }}
                          >
                            +
                          </button>
                        </div>
                        <div className="mt-3">
                          {cpsPresets.map(v => (
                            <button
                              key={v}
                              className={`btn btn-sm ${formData.limit_cps === v ? 'btn-primary' : 'btn-outline-secondary'} mr-2`}
                              onClick={() => this.handleCpsChange(v)}
                            >{v}</button>
                          ))}
                        </div>
                        <p className="text-soft small mt-2">Common presets — or type any custom number above.</p>
                      </div>

                      {/* ── Number of Sessions — RIGHT ── */}
                      <div className="col-md-6 d-flex justify-content-end">
                        <div className="pl-4" style={{ width: "100%" }}>
                          <h6 className="d-flex align-items-center justify-content-end title mb-1">NUMBER OF SESSIONS</h6>
                          <p className="d-flex align-items-center justify-content-end text-soft small mb-3">Maximum concurrent sessions allowed. Max: {maxSessions}.</p>
                          <div className="d-flex align-items-center justify-content-end">
                            <button
                              className="btn btn-outline-light btn-lg"
                              onClick={this.decrementSessions}
                              style={{ fontSize: "24px", padding: "10px 20px" }}
                            >
                              −
                            </button>
                            <input
                              type="number"
                              className="form-control form-control-lg text-center mx-3"
                              value={formData.limit_sessions}
                              onChange={(e) => this.handleSessionsChange(e.target.value)}
                              min={0}
                              max={maxSessions}
                              style={{ width: "120px", fontSize: "24px" }}
                            />
                            <button
                              className="btn btn-outline-light btn-lg"
                              onClick={this.incrementSessions}
                              style={{ fontSize: "24px", padding: "10px 20px" }}
                            >
                              +
                            </button>
                          </div>
                          <div className="mt-3 d-flex justify-content-end">
                            {sessionPresets.map(v => (
                              <button
                                key={v}
                                className={`btn btn-sm ${formData.limit_sessions === v ? 'btn-primary' : 'btn-outline-secondary'} ml-2`}
                                onClick={() => this.handleSessionsChange(v)}
                              >{v}</button>
                            ))}
                          </div>
                          <p className="text-soft small mt-2 text-right">Common presets — or type any custom number above.</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                {/* General Configuration */}
                <div className="card card-bordered mb-3">
                  <div className="card-inner">
                    <div className="d-flex align-items-center mb-3">
                      <div className="icon-circle bg-primary text-white mr-3" style={{ width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <em className="icon ni ni-setting"></em>
                      </div>
                      <div>
                        <h6 className="title mb-0">General Configuration</h6>
                        <p className="text-soft small mb-0">Name your trunk and set encryption, codecs, and call handling options.</p>
                      </div>
                    </div>

                    <div className="row g-3">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">
                            SELECT ACCOUNT <span className="text-danger">*</span>
                          </label>
                          {loadingAccounts ? (
                            <div className="text-center py-3">
                              <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="sr-only">Loading accounts...</span>
                              </div>
                              <span className="ml-2 text-soft">Loading SIP NAV accounts...</span>
                            </div>
                          ) : sipnavAccounts.length > 0 ? (
                            <select
                              className="form-control form-control-lg"
                              value={formData.selected_account_id}
                              onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedAccount = sipnavAccounts.find(acc => String(acc.account_id) === String(selectedId));
                                this.setState({
                                  formData: {
                                    ...this.state.formData,
                                    selected_account_id: selectedId,
                                    selected_client_name: selectedAccount ? selectedAccount.client_name : "",
                                  }
                                });
                              }}
                            >
                              <option value="">-- Select a SIP NAV Account --</option>
                              {sipnavAccounts.map((account) => (
                                <option key={account.account_id} value={account.account_id}>
                                  {account.client_name}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <div className="alert alert-light border" role="alert">
                              <em className="icon ni ni-info mr-2"></em>
                              No SIP NAV accounts available. Please create an account first by completing the SIP NAV integration forms.
                            </div>
                          )}
                          <span className="form-note">
                            Select the SIP NAV account for which you want to create a trunk. Only accounts with completed integrations are shown.
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">SIP TRUNK NAME <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            placeholder="My SIP Trunk"
                            value={formData.trunk_name}
                            onChange={(e) => this.handleInputChange("trunk_name", e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">DTMF</label>
                          <select
                            className="form-control form-control-lg"
                            value={formData.dtmf}
                            onChange={(e) => this.handleInputChange("dtmf", e.target.value)}
                          >
                            <option value="in-band">In-band</option>
                            <option value="rfc2833">RFC2833</option>
                            <option value="sip-info">SIP INFO</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">TLS ENCRYPTION</label>
                          <p className="mb-2">
                            <strong className={formData.tls_encryption ? "text-success" : "text-muted"}>
                              {formData.tls_encryption ? "Enabled" : "Disabled"}
                            </strong>
                          </p>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="tlsSwitch"
                              checked={formData.tls_encryption}
                              onChange={(e) => this.handleInputChange("tls_encryption", e.target.checked)}
                            />
                            <label className="custom-control-label" htmlFor="tlsSwitch">
                              Toggle encryption
                            </label>
                          </div>
                          <p className="text-soft small mt-1 mb-0">Encrypts SIP signalling using TLS 1.2+</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">FAX</label>
                          <select
                            className="form-control form-control-lg"
                            value={formData.fax}
                            onChange={(e) => this.handleInputChange("fax", e.target.value)}
                          >
                            <option value="none">None</option>
                            <option value="t38">T.38</option>
                            {/* <option value="passthrough">Passthrough</option> */}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">CODECS — CLICK TO TOGGLE PRIORITY</label>
                          <div className="d-flex flex-wrap">
                            {["g729", "pcma", "pcmu", "g722", "g711"].map((codec) => {
                              const isSelected = formData.codecs.includes(codec);
                              const priorityNumber = isSelected ? formData.codecs.indexOf(codec) + 1 : null;
                              return (
                                <button
                                  key={codec}
                                  type="button"
                                  className={`btn border mr-2 mb-2 ${isSelected ? "btn-primary" : "btn-outline-gray"}`}
                                  onClick={() => this.toggleCodec(codec)}
                                >
                                  {isSelected && <em className="icon ni ni-check mr-1"></em>}
                                  <span>{codec.toUpperCase()}</span>
                                  {isSelected && (
                                    <span
                                      style={{
                                        backgroundColor: "rgba(28, 43, 70, 0.8)",
                                        color: "white",
                                        borderRadius: "50%",
                                        width: "18px",
                                        height: "18px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "11px",
                                        fontWeight: "bold",
                                        marginLeft: "6px",
                                        paddingLeft: "0"
                                      }}
                                    >
                                      {priorityNumber}
                                    </span>
                                  )}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">NUMBER FORMAT</label>
                          <select
                            className="form-control form-control-lg"
                            value={formData.number_format}
                            onChange={(e) => this.handleInputChange("number_format", e.target.value)}
                          >
                            <option value="e164">E164</option>
                            <option value="national">National</option>
                            {/* <option value="international">International</option> */}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Outbound Route */}
                <div className="card card-bordered mb-3">
                  <div className="card-inner">
                    <div className="d-flex align-items-center mb-3">
                      <div className="icon-circle bg-info text-white mr-3" style={{ width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <em className="icon ni ni-arrow-up-right"></em>
                      </div>
                      <div>
                        <h6 className="title mb-0">Outbound Route</h6>
                        <p className="text-soft small mb-0">Specify the IP address(es) to which your DID calls should be routed. Add multiple IPs for redundant routing strategies.</p>
                      </div>
                    </div>

                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">DESTINATION HOST</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. 34.71.221.129 or FQDN"
                            value={tempDestHost}
                            onChange={(e) => this.setState({ tempDestHost: e.target.value })}
                          />
                          <span className="form-note">Enter IP or FQDN</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">TECH PREFIX</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="#"
                            value={tempDestTechPrefix}
                            onChange={(e) => this.setState({ tempDestTechPrefix: e.target.value.replace(/[^0-9]/g, "").slice(0, 7) })}
                            maxLength={7}
                          />
                          <span className="form-note">Numbers only, max 7 digits. Leave blank for none.</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">TYPE</label>
                          <select
                            className="form-control"
                            value={tempDestType}
                            onChange={(e) => this.setState({ tempDestType: e.target.value })}
                          >
                            <option value="termination">Termination</option>
                            <option value="origination">Origination</option>
                            <option value="both">Both</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">&nbsp;</label>
                        <button className="btn btn-outline-primary btn-block" onClick={this.addDestHost}>
                          <em className="icon ni ni-plus mr-1"></em>
                          ADD
                        </button>
                      </div>
                    </div>

                    {formData.destination_hosts.length > 0 ? (
                      <div className="mt-3">
                        <div style={{ backgroundColor: "#f5f6fa", borderRadius: "4px", padding: "12px 16px", border: "1px solid #e5e9f2" }}>
                          <div style={{ display: "flex", alignItems: "center", color: "#8094ae", fontSize: "11px", fontWeight: "600", letterSpacing: "0.5px", marginBottom: "12px", paddingLeft: "20px" }}>
                            <div style={{ flex: "2 1 0%" }}>HOST</div>
                            <div style={{ flex: "1 1 0%" }}>TECH PREFIX</div>
                            <div style={{ flex: "1 1 0%" }}>TYPE</div>
                            <div style={{ width: "30px" }}></div>
                          </div>
                          {formData.destination_hosts.map((h, index) => (
                            <div
                              key={index}
                              draggable
                              onDragStart={() => this.handleDestDragStart(index)}
                              onDragOver={(e) => this.handleDestDragOver(e, index)}
                              onDrop={(e) => this.handleDestDrop(e, index)}
                              style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "white", borderRadius: "4px", marginBottom: index < formData.destination_hosts.length - 1 ? "8px" : "0", cursor: "move", border: "1px solid #e5e9f2" }}
                            >
                              <div style={{ marginRight: "12px" }}>
                                <span style={{ color: "#8094ae", fontSize: "16px", cursor: "grab" }}>::</span>
                              </div>
                              <div style={{ flex: "2 1 0%" }}>
                                <span style={{ color: "#364a63", fontSize: "13px" }}>{h.ip}</span>
                              </div>
                              <div style={{ flex: "1 1 0%" }}>
                                <span style={{ color: "#364a63", fontSize: "13px" }}>{h.tech_prefix ? `#${h.tech_prefix}` : "—"}</span>
                              </div>
                              <div style={{ flex: "1 1 0%" }}>
                                <span style={{ color: "#364a63", fontSize: "13px", textTransform: "capitalize" }}>{h.type}</span>
                              </div>
                              <div style={{ marginLeft: "8px" }}>
                                <button className="host-remove-btn" style={{ background: "none", border: "none", color: "#8094ae", fontSize: "18px", cursor: "pointer", padding: "4px 6px", lineHeight: "1", borderRadius: "4px" }}
                                  onMouseEnter={(e) => { e.target.style.color = "#e85347"; e.target.style.backgroundColor = "#ffe9e7"; }}
                                  onMouseLeave={(e) => { e.target.style.color = "#8094ae"; e.target.style.backgroundColor = "transparent"; }}
                                  onClick={() => this.removeDestHost(index)}>×</button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div style={{ backgroundColor: "#f5f6fa", border: "1px solid #e5e9f2", borderRadius: "4px", padding: "24px", textAlign: "center", marginTop: "12px" }}>
                        <em className="icon ni ni-inbox" style={{ fontSize: "32px", color: "#c4cefe", marginBottom: "8px" }}></em>
                        <p style={{ margin: "0", color: "#8094ae", fontSize: "13px" }}>No destination hosts added</p>
                      </div>
                    )}

                    <div className="custom-control custom-checkbox mt-3">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="resolveSRV"
                        checked={formData.resolve_srv}
                        onChange={(e) => this.handleInputChange("resolve_srv", e.target.checked)}
                      />
                      <label className="custom-control-label" htmlFor="resolveSRV">
                        Resolve SRV records
                        <Tooltip title="When enabled, DNS SRV records are resolved to find the SIP server" placement="top">
                          <span 
                            className="ml-1"
                            style={{ cursor: "help", color: "#8094ae" }}
                          >
                            <em className="icon ni ni-info"></em>
                          </span>
                        </Tooltip>
                      </label>
                    </div>

                    <div className="form-group mt-3">
                      <label className="form-label">ROUTING STRATEGY</label>
                      <select
                        className="form-control"
                        value={formData.routing_strategy}
                        onChange={(e) => this.handleInputChange("routing_strategy", e.target.value)}
                      >
                        <option value="failover">Failover</option>
                        <option value="round-robin">Round Robin</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Inbound Route */}
                <div className="card card-bordered mb-3">
                  <div className="card-inner">
                    <div className="d-flex align-items-center mb-3">
                      <div className="icon-circle bg-success text-white mr-3" style={{ width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <em className="icon ni ni-arrow-down-left"></em>
                      </div>
                      <div>
                        <h6 className="title mb-0">Inbound Route</h6>
                        <p className="text-soft small mb-0">Specify all IP addresses from which you will source traffic to our network. We will allowlist only these sources.</p>
                      </div>
                    </div>

                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">SOURCE HOST <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. 34.71.229.90"
                            value={tempSourceHost}
                            onChange={(e) => this.setState({ tempSourceHost: e.target.value })}
                          />
                          <span className="form-note">Enter IP address</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">TECH PREFIX</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="#"
                            value={tempSourceTechPrefix}
                            onChange={(e) => this.setState({ tempSourceTechPrefix: e.target.value.replace(/[^0-9]/g, "").slice(0, 7) })}
                            maxLength={7}
                          />
                          <span className="form-note">Numbers only, max 7 digits. Leave blank for none.</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="form-label">TYPE</label>
                          <select
                            className="form-control"
                            value={tempSourceType}
                            onChange={(e) => this.setState({ tempSourceType: e.target.value })}
                          >
                            <option value="termination">Termination</option>
                            <option value="origination">Origination</option>
                            <option value="both">Both</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">&nbsp;</label>
                        <button className="btn btn-outline-primary btn-block" onClick={this.addSourceHost}>
                          <em className="icon ni ni-plus mr-1"></em>
                          ADD
                        </button>
                      </div>
                    </div>

                    {formData.source_hosts.length > 0 ? (
                      <div className="mt-3">
                        <div style={{ backgroundColor: "#f5f6fa", borderRadius: "4px", padding: "12px 16px", border: "1px solid #e5e9f2" }}>
                          <div style={{ display: "flex", alignItems: "center", color: "#8094ae", fontSize: "11px", fontWeight: "600", letterSpacing: "0.5px", marginBottom: "12px", paddingLeft: "20px" }}>
                            <div style={{ flex: "2 1 0%" }}>HOST</div>
                            <div style={{ flex: "1 1 0%" }}>TECH PREFIX</div>
                            <div style={{ flex: "1 1 0%" }}>TYPE</div>
                            <div style={{ width: "30px" }}></div>
                          </div>
                          {formData.source_hosts.map((h, index) => (
                            <div
                              key={index}
                              draggable
                              onDragStart={() => this.handleSourceDragStart(index)}
                              onDragOver={(e) => this.handleSourceDragOver(e, index)}
                              onDrop={(e) => this.handleSourceDrop(e, index)}
                              style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "white", borderRadius: "4px", marginBottom: index < formData.source_hosts.length - 1 ? "8px" : "0", cursor: "move", border: "1px solid #e5e9f2" }}
                            >
                              <div style={{ marginRight: "12px" }}>
                                <span style={{ color: "#8094ae", fontSize: "16px", cursor: "grab" }}>::</span>
                              </div>
                              <div style={{ flex: "2 1 0%" }}>
                                <span style={{ color: "#364a63", fontSize: "13px" }}>{h.ip}</span>
                              </div>
                              <div style={{ flex: "1 1 0%" }}>
                                <span style={{ color: "#364a63", fontSize: "13px" }}>{h.tech_prefix ? `#${h.tech_prefix}` : "—"}</span>
                              </div>
                              <div style={{ flex: "1 1 0%" }}>
                                <span style={{ color: "#364a63", fontSize: "13px", textTransform: "capitalize" }}>{h.type}</span>
                              </div>
                              <div style={{ marginLeft: "8px" }}>
                                <button className="host-remove-btn" style={{ background: "none", border: "none", color: "#8094ae", fontSize: "18px", cursor: "pointer", padding: "4px 6px", lineHeight: "1", borderRadius: "4px" }}
                                  onMouseEnter={(e) => { e.target.style.color = "#e85347"; e.target.style.backgroundColor = "#ffe9e7"; }}
                                  onMouseLeave={(e) => { e.target.style.color = "#8094ae"; e.target.style.backgroundColor = "transparent"; }}
                                  onClick={() => this.removeSourceHost(index)}>×</button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div style={{
                        backgroundColor: "#f5f6fa",
                        border: "1px solid #e5e9f2",
                        borderRadius: "4px",
                        padding: "24px",
                        textAlign: "center",
                        marginTop: "12px"
                      }}>
                        <em className="icon ni ni-inbox" style={{ fontSize: "32px", color: "#c4cefe", marginBottom: "8px" }}></em>
                        <p style={{ margin: "0", color: "#8094ae", fontSize: "13px" }}>No source hosts added yet</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="card card-bordered">
                  <div className="card-inner">
                    <div className="d-flex justify-content-between">
                      <button className="btn btn-outline-light" onClick={this.handleGoBack}>
                        <em className="icon ni ni-cross mr-1"></em>
                        Cancel
                      </button>
                      <button className="btn btn-primary btn-lg" onClick={this.handleContinue}>
                        Review
                        <em className="icon ni ni-arrow-right ml-1"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Step 2: Review */}
            {currentStep === 2 && (
              <div className="nk-block">
                <div className="card card-bordered mb-3">
                  <div className="card-inner">
                    <h5 className="mb-4">
                      <em className="icon ni ni-file-text mr-2"></em>
                      Configuration Summary
                    </h5>

                    <div className="row g-gs">
                      <div className="col-md-6">
                        <table className="table table-borderless">
                          <tbody>
                            {/* <tr>
                              <td className="text-soft">SIP NAV Account</td>
                              <td className="text-right">
                                <strong>
                                  {(() => {
                                    const selectedAccount = sipnavAccounts.find(
                                      acc => String(acc.account_id) === String(formData.selected_account_id)
                                    );
                                    return selectedAccount 
                                      ? `${selectedAccount.client_name} (ID: ${selectedAccount.account_id})`
                                      : "N/A";
                                  })()}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-soft">Provider</td>
                              <td className="text-right"><strong>VoiceAlerts</strong></td>
                            </tr> */}
                            <tr>
                              <td className="text-soft">SIP Trunk Name</td>
                              <td className="text-right"><strong>{formData.trunk_name}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-soft">Codecs</td>
                              <td className="text-right"><strong>{formData.codecs.map(c => c.toUpperCase()).join(" > ")}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-soft">Fax</td>
                              <td className="text-right"><strong>{formData.fax.charAt(0).toUpperCase() + formData.fax.slice(1)}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-soft">Number Format</td>
                              <td className="text-right"><strong>{formData.number_format.toUpperCase()}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-md-6">
                        <table className="table table-borderless">
                          <tbody>
                            <tr>
                              <td className="text-soft">Limit Sessions</td>
                              <td className="text-right"><strong>{formData.limit_sessions}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-soft">Calls Per Second</td>
                              <td className="text-right"><strong>{formData.limit_cps}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-soft">TLS Encryption</td>
                              <td className="text-right"><strong>{formData.tls_encryption ? "Enabled" : "Disabled"}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-soft">DTMF</td>
                              <td className="text-right"><strong>{formData.dtmf.charAt(0).toUpperCase() + formData.dtmf.slice(1)}</strong></td>
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Hosts Summary */}
                <div className="row g-gs mb-4">
                  <div className="col-md-6">
                    <div className="card card-bordered h-100">
                      <div className="card-inner">
                        <h6 className="mb-3">
                          <em className="icon ni ni-arrow-down-left text-success mr-2"></em>
                          Inbound (Source) Hosts
                        </h6>
                        {formData.source_hosts.length > 0 ? (
                          <ul className="list-unstyled">
                            {formData.source_hosts.map((h, index) => (
                              <li key={index} className="mb-2">
                                <code style={{ color: "#1ee0ac" }}>{h.ip}</code>
                                {h.tech_prefix && <span className="text-soft ml-2">prefix: {h.tech_prefix}#</span>}
                                <span className="badge badge-dim badge-secondary ml-2" style={{ textTransform: "capitalize" }}>{h.type}</span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-soft">No source hosts configured</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card card-bordered h-100">
                      <div className="card-inner">
                        <h6 className="mb-3">
                          <em className="icon ni ni-arrow-up-right text-info mr-2"></em>
                          Outbound (Destination) Hosts
                        </h6>
                        {formData.destination_hosts.length > 0 ? (
                          <ul className="list-unstyled">
                            {formData.destination_hosts.map((h, index) => (
                              <li key={index} className="mb-2">
                                <code style={{ color: "#09c2de" }}>{h.ip}</code>
                                {h.tech_prefix && <span className="text-soft ml-2">prefix: {h.tech_prefix}#</span>}
                                <span className="badge badge-dim badge-info ml-2" style={{ textTransform: "capitalize" }}>{h.type}</span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-soft font-italic">not configured</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* IP Assignments Info */}
                <div className="card card-bordered mb-3" style={{ backgroundColor: "#f5f6fa", marginTop: "30px" }}>
                  <div className="card-inner">
                    <h6 className="mb-3 text-uppercase" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      IP ADDRESS ASSIGNMENTS — ALLOWLIST THESE IPS
                    </h6>
                    <div className="row g-gs">
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded">
                          <div className="d-flex align-items-center mb-2">
                            <em className="icon ni ni-shield-check text-primary mr-2" style={{ fontSize: "20px" }}></em>
                            <strong>Primary IPs</strong>
                          </div>
                          <p className="text-soft small mb-2">Allowlist these IPs on your infrastructure.</p>
                          <div>
                            {accountIps.length > 0 ? accountIps.map((ip, i) => (
                              <span key={i} className="badge badge-dim badge-primary mr-2 mb-1">{ip}</span>
                            )) : (
                              <span className="text-muted small">No primary IPs configured</span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded">
                          <div className="d-flex align-items-center mb-2">
                            <em className="icon ni ni-network text-success mr-2" style={{ fontSize: "20px" }}></em>
                            <strong>Backup IPs</strong>
                          </div>
                          <p className="text-soft small mb-2">Allowlist these backup IPs on your infrastructure.</p>
                          <div>
                            {carrierIps.length > 0 ? carrierIps.map((ip, i) => (
                              <span key={i} className="badge badge-dim badge-success mr-2 mb-1">{ip}</span>
                            )) : (
                              <span className="text-muted small">No backup IPs configured</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="card card-bordered">
                  <div className="card-inner">
                    <div className="d-flex justify-content-between">
                      <button className="btn btn-outline-light" onClick={this.handleBack} disabled={loading}>
                        <em className="icon ni ni-arrow-left mr-1"></em>
                        Back
                      </button>
                      <button className="btn btn-success btn-lg" onClick={this.handleSubmit} disabled={loading}>
                        {loading ? (
                          <>
                            <em className="icon ni ni-loader mr-1"></em>
                            Creating Trunk...
                          </>
                        ) : (
                          <>
                            <em className="icon ni ni-check-circle mr-1"></em>
                            Confirm and Active Trunk
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AddTrunk;
